<template src="./Dashboard.html"></template>

<script>
import { mapActions, mapState } from "vuex";
import html2canvas from "html2canvas";

// Private libs
import PanelIconValues from "@/components/Panels/IconValues/PanelIconValues.vue";
import Chart from "@/components/Chart/Chart.vue";
import MenuIcon from '@/components/Menu/MenuIcon/MenuIcon.vue';

export default {
  name: "Dashboard",
  props: ["dashboardActiveTab", "onLoadDataClick", "startDate", "endDate"],
  components: {
    PanelIconValues,
    Chart,
    MenuIcon,
  },
  data() {
    return {
      banana: '2',
      loadingCharts: {}
    };
  },
  computed: {
    ...mapState({
      mapLatLon: (state) => state.mapLatLon,
      latLonInfo: (state) => state.latLonInfo,

      variable: (state) => state.menuSettings.variable,

      pixelStats: (state) => state.pixelStats,
      pixelSeasonSummary: (state) => state.pixelSeasonSummary,

      variableConfig: (state) => state.variables.variables,

      pixelData: (state) => state.pixel.variablePixelData,

      pixelDataHis: (state) => state.pixel.pixelDataHis,

    }),

    pixelStatsDashboard() {
      const targetYear = this.endDate.split('-')[0]; // Extract year from end date
      const endYearData = this.pixelSeasonSummary.find(el => el.date && el.date.startsWith(targetYear)) || {}; 
      console.log(endYearData,this.pixelSeasonSummary, 'endYearData')       
        return {
            totR: {
                max: this.pixelStats.totR ? this.pixelStats.totR.max.totR.toFixed(this.variableConfig['totR'].round) : null,
                maxDate: this.pixelStats.totR ? this.pixelStats.totR.max.date : null,
                min: this.pixelStats.totR ? this.pixelStats.totR.min.totR.toFixed(this.variableConfig['totR'].round) : null,
                minDate: this.pixelStats.totR ? this.pixelStats.totR.min.date : null,
                avg: this.pixelStats.totR ? this.pixelStats.totR.avg.avg.toFixed(this.variableConfig['totR'].round) : null,
                endyear: endYearData.totR ? endYearData.totR.toFixed(this.variableConfig['totR'].round) : null,
                endyearDescription: targetYear,
            },
            minT: {
                max: this.pixelStats.minT ? this.pixelStats.minT.max.minT.toFixed(this.variableConfig['minT'].round) : null,
                maxDate: this.pixelStats.minT ? this.pixelStats.minT.max.date : null,
                minDate: this.pixelStats.minT ? this.pixelStats.minT.min.date : null,
                min: this.pixelStats.minT ? this.pixelStats.minT.min.minT.toFixed(this.variableConfig['minT'].round) : null,
                avg: this.pixelStats.minT ? this.pixelStats.minT.avg.avg.toFixed(this.variableConfig['minT'].round) : null,
                endyear: endYearData.minT ? endYearData.minT.toFixed(this.variableConfig['minT'].round) : null,
                endyearDescription: targetYear
            },
            avgT: {
                max: this.pixelStats.avgT ? this.pixelStats.avgT.max.avgT.toFixed(this.variableConfig['avgT'].round) : null,
                min: this.pixelStats.avgT ? this.pixelStats.avgT.min.avgT.toFixed(this.variableConfig['avgT'].round) : null,
                avg: this.pixelStats.avgT ? this.pixelStats.avgT.avg.avg.toFixed(this.variableConfig['avgT'].round) : null,
                maxDate: this.pixelStats.avgT ? this.pixelStats.avgT.max.date : null,
                minDate: this.pixelStats.avgT ? this.pixelStats.avgT.min.date : null,
                endyear: endYearData.avgT ? endYearData.avgT.toFixed(this.variableConfig['avgT'].round) : null,
                endyearDescription: targetYear
            },
            maxT: {
                max: this.pixelStats.maxT ? this.pixelStats.maxT.max.maxT.toFixed(this.variableConfig['maxT'].round) : null,
                min: this.pixelStats.maxT ? this.pixelStats.maxT.min.maxT.toFixed(this.variableConfig['maxT'].round) : null,
                avg: this.pixelStats.maxT ? this.pixelStats.maxT.avg.avg.toFixed(this.variableConfig['maxT'].round) : null,
                maxDate: this.pixelStats.maxT ? this.pixelStats.maxT.max.date : null,
                minDate: this.pixelStats.maxT ? this.pixelStats.maxT.min.date : null,
                endyear: endYearData.maxT ? endYearData.maxT.toFixed(this.variableConfig['maxT'].round) : null,
                endyearDescription: targetYear
            },
        }
    },


    getDashTotRChart() {

      if (this.pixelSeasonSummary.length == 0) return [];

      return [{
          x: this.pixelSeasonSummary.map((el) => el.date),
          y: this.pixelSeasonSummary.map((el) => el.totR),
          yaxis: this.variableConfig['totR'].chart.axis,
          name: this.variableConfig['totR'].description,
          layout: {
            title: this.variableConfig['totR'].description,
          },
          type: 'bar'
      }];
    },

    getDashDrySpellChart() {
      if (this.pixelDataHis.length == 0) return [];
      
      return [{
          x: this.pixelDataHis.map((el) => el.date),
          y: this.pixelDataHis.map((el) => el['drySpell']),
          yaxis: this.variableConfig['drySpell'].chart.axis,
          name: this.variableConfig['drySpell'].description,
          layout: {
            title: this.variableConfig['drySpell'].description,
          },
          type: 'bar'
      }];
    },

    getDashWetSpellChart() {
      if (this.pixelDataHis.length == 0) return [];
      
      return [{
          x: this.pixelDataHis.map((el) => el.date),
          y: this.pixelDataHis.map((el) => el['wetSpell']),
          yaxis: this.variableConfig['wetSpell'].chart.axis,
          name: this.variableConfig['wetSpell'].description,
          layout: {
            title: this.variableConfig['wetSpell'].description,
          },
          type: 'bar'
      }];
    },

    getDashTempChart() {
      if (this.pixelSeasonSummary.length == 0) return [];

      let charts = [];

      ['maxT', 'avgT', 'minT'].map((variable) => {
        charts.push({
          x: this.pixelSeasonSummary.map((el) => el.date),
          y: this.pixelSeasonSummary.map((el) => el[variable]),
          yaxis: this.variableConfig[variable].chart.axis,
          name: this.variableConfig[variable].description,
          layout: {
            title: this.variableConfig[variable].description,
          },
          type: 'scatter'
        });
      });
      return charts;
    }

  },

  methods: {
    ...mapActions({
      getPixelStats: "getPixelStats",

      getPixelSeasonSummary: "getPixelSeasonsSummaryDashboard",
      trackLoading: "trackLoading",
    }),


    ...mapActions('pixel', {
      getModelData: "getPixelModelData",
    }),


    // Runs every time the tab is opened (and on Load Data / date changes), so the
    // panel's pre-loader is kept on until all of it arrives (trackLoading).
    loadClimateData() {
      const requests = [];

      requests.push(this.getModelData({
        latitude: this.mapLatLon.latitude,
        longitude: this.mapLatLon.longitude,
        begin: this.startDate.replaceAll('-', ''),
        end: this.endDate.replaceAll('-', ''),
        agg: "1D",
        interval: "daily",
        variable: {
          id: 'wetSpellHis',
          threshold: null
        }
      }));

      requests.push(this.getModelData({
        latitude: this.mapLatLon.latitude,
        longitude: this.mapLatLon.longitude,
        begin: this.startDate.replaceAll('-', ''),
        end: this.endDate.replaceAll('-', ''),
        agg: "1D",
        interval: "daily",
        variable: {
          id: 'drySpellHis',
          threshold: null
        }
      }));

      let vars = ["minT", "avgT", "maxT", "totR"].map((v) => {
        return {
          id: v,
          threshold: this.variableConfig[v].threshold.required ? this.variableConfig[v].threshold.default : null,
          type: this.variableConfig[v].type,
          dataObservation: this.variableConfig[v].dataObservation,
        };
      });
      
      const params = {
        latitude: this.mapLatLon.latitude,
        longitude: this.mapLatLon.longitude,
        startDate: this.startDate,
        endDate: this.endDate,
        agg: "1D", //this.selectAggregationPeriod.select.id,
        variables: vars,
      };

      // get season statistics
      requests.push(this.getPixelStats(params));

      // Load data
      requests.push(this.getPixelSeasonSummary({
        latitude: this.mapLatLon.latitude,
        longitude: this.mapLatLon.longitude,
        startDate: this.startDate,
        endDate: this.endDate,
        variables: vars,
      }));

      this.trackLoading(requests);

    },

    exportChartAsImage(chartRefName, filename) {
      this.loadingCharts = {...this.loadingCharts, [chartRefName]: true };
      setTimeout(() => {
        try {
          const chartElement = this.$refs[chartRefName];
          if (!chartElement) {
            // console.error(`Chart with ref "${chartRefName}" not found.`);
            this.loadingCharts = {...this.loadingCharts, [chartRefName]: false };
            return;
          }

          // Options for html2canvas
          const options = {
            useCORS: true,
            allowTaint: true,
            scale: window.devicePixelRatio || 1, // Use device pixel ratio for better resolution
            // Ensure scroll position doesn't affect capture
            scrollX: 0,
            scrollY: -window.scrollY,
            windowWidth: document.documentElement.offsetWidth,
            windowHeight: document.documentElement.offsetHeight,
          };

          html2canvas(chartElement.$el || chartElement, options)
            .then((chartCanvas) => {
              // 1. Create an in-memory image from the chart canvas
              const chartImage = new Image();
              chartImage.onload = () => {
                // 2. Load the logo
                const logo = new Image();
                logo.src = "https://cloud.agroclimate.org/tools/climate-indicators-monitoring/agroclimate_main_logo.png";
                logo.crossOrigin = "anonymous";

                logo.onload = () => {
                  // 3. Create a new canvas to combine chart and logo
                  const finalCanvas = document.createElement("canvas");
                  finalCanvas.width = chartCanvas.width;
                  finalCanvas.height = chartCanvas.height;
                  const ctx = finalCanvas.getContext("2d");

                  // 4. Draw the captured chart image onto the new canvas
                  ctx.drawImage(chartImage, 0, 0);

                  // 5. Calculate logo position on the new canvas (bottom-right)
                  const padding = 20 * options.scale; // Scale padding
                  const logoWidth = 30 * options.scale; // Scale logo size
                  const logoHeight = (logo.height / logo.width) * logoWidth;
                  const x = finalCanvas.width - logoWidth - padding;
                  const y = padding;

                  // 6. Draw the logo onto the new canvas
                  ctx.drawImage(logo, x, y, logoWidth, logoHeight);

                  // 7. Generate the final image and trigger download
                  try {
                    const link = document.createElement("a");
                    link.download = `${filename || chartRefName}.png`;
                    link.href = finalCanvas.toDataURL("image/png");
                    link.click();
                  } catch (err) {
                    console.error("Error creating download link:", err);
                  } finally {
                    // this.loadingCharts[chartRefName] = false;
                    this.loadingCharts = {...this.loadingCharts, [chartRefName]: false };
                  }
                };

                logo.onerror = (err) => {
                  console.error("Error loading logo:", err);
                  // Proceed to download chart without logo if logo fails
                  try {
                    const link = document.createElement("a");
                    link.download = `${filename || chartRefName}.png`;
                    // Use the original chart canvas data URL
                    link.href = chartCanvas.toDataURL("image/png");
                    link.click();
                  } catch (linkErr) {
                    console.error(
                      "Error creating download link (no logo):",
                      linkErr
                    );
                  } finally {
                    // this.loadingCharts[chartRefName] = false;
                    this.loadingCharts = {};
                  }
                };
              };

              chartImage.onerror = (err) => {
                console.error("Error loading chart canvas into image:", err);
                this.loadingCharts = {...this.loadingCharts, [chartRefName]: false };
                // this.loadingCharts[chartRefName] = false;
                // this.loadingCharts = {};
              };

              // Set the source for the chart image *after* defining onload
              chartImage.src = chartCanvas.toDataURL("image/png");
            })
            .catch((err) => {
              console.error("Error generating canvas with html2canvas:", err);
              this.loadingCharts = {...this.loadingCharts, [chartRefName]: false };
              // this.loadingCharts[chartRefName] = false;
              // this.loadingCharts = {};
            });
        } catch (error) {
          console.error("Error exporting chart as image:", error);
          this.loadingCharts = {...this.loadingCharts, [chartRefName]: false };
          // this.loadingCharts[chartRefName] = false;
          // this.loadingCharts = {};
        }
      }, 200);
    },

    exportChartAsCSV(chartRefName, filename) {
      // console.log("this[chartRefName]");
      // console.log(this[chartRefName]);

      const chartData = this[chartRefName];

      // console.log("chartData");
      // console.log(chartData);

      if (chartData.length == 0) {
        console.error(`Chart with ref "${chartRefName}" has no data.`);
        return;
      }

      const LEN_CHART = chartData[0].x.length;

      if (LEN_CHART == 0) {
        console.error(`Chart with ref "${chartRefName}" has no data.`);
        return;
      }

      let csvRows = [];

      // Add data
      for (let i = 0; i < LEN_CHART; i++) {
        let newRow = {};
        newRow['date'] = chartData[0].x[i];

        for (let j = 0; j < chartData.length; j++) {
          let propName = chartData[j].name;
          propName = propName.replaceAll(' ', '_');
          propName = propName.replaceAll(',', '');
          propName = propName.replaceAll('°', '');
          propName = propName.toLowerCase();

          newRow[propName] = chartData[j].y[i];
        }
        csvRows.push(newRow);
      }

      // Convert to csv and download
      const header = Object.keys(csvRows[0]).join(",") + "\n";
      const rows = csvRows.map(obj => Object.values(obj).join(",")).join("\n");
      const csvContent = header + rows;

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", `${filename}.csv`);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
  },
  mounted() {
    if (this.dashboardActiveTab == 0) {
      this.loadClimateData();
    }
  },

  watch: {
    dashboardActiveTab: function () {
      if (this.dashboardActiveTab == 0) {
        this.loadClimateData();
      }
    },
    startDate: function () {
      if (this.dashboardActiveTab == 0) {
        this.loadClimateData();
      }
    },
    endDate: function () {
      if (this.dashboardActiveTab == 0) {
        this.loadClimateData();
      }
    },
    onLoadDataClick: function () {
      if (this.dashboardActiveTab == 0) {
        this.loadClimateData();
      }
    }
  },
};
</script>

<style lang="scss" src="./Dashboard.scss"></style>